import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../navigation/Auth/auth";

export function useForm(initialFValues, validateOnChange = false, validate) {
  const location = useLocation();
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const redirectPath = location.state?.path || "/dashboard";
  const [loginInput, setLogin] = useState({
    mobile_number: "",
    password: "",
    password_confirmation:"",
    code:"",
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLogin({ ...loginInput, [name]: value });

    if (validateOnChange) validate({ [name]: value });
  };
  const handlefile = (e) => {
    setLogin({ ...loginInput, [e.target.name]: e.target.files[0] });

    if (validateOnChange) validate({ [e.target.name]: e.target.files[0] });
  };

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  };

  const addForm = () => {
    if (validate()) {
    }
  };

  return {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    handlefile,
    addForm,
    resetForm,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormControl-root": {
      width: "80%",
      margin: theme.spacing(1),
    },
  },
}));

export function Form(props) {
  const classes = useStyles();
  const { children, ...other } = props;
  return (
    <form className={classes.root} autoComplete="off" {...other}>
      {props.children}
    </form>
  );
}
